import { useTranslation } from 'react-i18next'

const Classmate2End = (props) => {
  const { t } = useTranslation()

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="classmate2-after-title"
      fill="none"
      {...props}
    >
      <title id="classmate2-after-title">{t('antagonists:classmate2:components:end')}</title>
      <defs>
        <clipPath id="classmate2-b">
          <path
            d="M1485.27 952.93c8.32.32 17.21 10.49 18.71 10.83 4.08.92.54-6.83 1.71-7.07 1.17-.24 3.39 8.43 4.41 16.08 1.02 7.65 1.53 11.05.17 12.07-1.36 1.02-13.59 6.63-14.95 10.71-1.36 4.08-4.42 15.12-17.5 16.31s-23.79-.51-24.47-4.59c-.68-4.08-1.53-11.9 1.53-15.8 3.06-3.91 9.69-7.65 13.42-14.78 3.74-7.14 7.63-15.9 8.9-18.36 1.38-2.67 3.66-5.55 8.08-5.38Z"
            style={{
              fill: '#497125',
            }}
          />
        </clipPath>
        <clipPath id="classmate2-c">
          <path
            d="M1570.77 954.91c-1.28-.33-3.11 11.65-4.08 15.97-1.8 8.05-.34 15.46.17 16.99.51 1.53 18.52 2.21 28.89 7.65 10.37 5.44 20.56 7.99 32.46 7.99 11.9 0 20.39-4.59 21.24-7.14.85-2.55 2.89-10.03-1.19-12.24-4.08-2.21-18.18-6.8-24.13-10.37-5.95-3.57-23.39-24.9-32.73-19.97-9.35 4.93-10.43 16.74-15.87 14.19-5.44-2.55-3.47-12.75-4.76-13.08Z"
            style={{
              fill: '#497125',
            }}
          />
        </clipPath>
        <clipPath id="classmate2-d">
          <path
            d="M1543.91 377.36c29.82-4.02 39.54 16.1 44.64 33.88 5.1 17.78.13 30.68.55 44.22.42 13.55 12.02 44.65 12.02 44.65l-9.21 2.92s-12.18-17.6-14.69-26.43c-3.36-11.83-3.58-30.59-3.58-30.59l-47.82.22s3.51 16.99 2.44 30.31c-1.06 13.32-3.95 25.36-3.95 25.36l-14.52 1.11s-.91-4.67 1.45-18.19c1.82-10.44 2.99-22.35 1.08-39.33-.74-6.57-6.46-28.93-2.19-43.34 3.78-12.76 14.6-22.19 33.78-24.77Z"
            style={{
              fill: '#394a35',
            }}
          />
        </clipPath>
        <clipPath id="classmate2-e">
          <path
            d="M1449.76 662.5s-7.3-2.41-8.59-14.22c-1.29-11.8 8-25.86 17.08-55.68 9.09-29.82 14.68-76.65 24.21-90.67 3.88-5.71 17.54-10.53 22.65-11.38 10.68-1.78 14.95-3.92 14.95-3.92s10.01 8.02 33.08 8.96c22.36.91 29.76-8.27 29.76-8.27s13.96 8.07 21.52 10.43c7.35 2.29 17.79 9.67 21.35 20.91 2.14 6.76.31 37.37 6.32 62.46 6.01 25.09 19.86 44.65 21.92 55.27 4.02 20.68-1.8 22.47-1.8 22.47l.37 15.05-20 5.38-5.31-11.7-4.8-7.45s-4.96 23.01-3.97 29.48c2.7 17.65-16.68 22.65-16.68 22.65s-23.08-7.73-46.49-6.01c-23.41 1.72-70.4 9.36-70.4 9.36s-9.67.35-10.36-12.49c-.66-12.33.47-28.31.53-32.55-2.16 6.37-5.4 15.55-5.4 15.55l-22.59-5.7 2.64-17.94Z"
            style={{
              fill: '#c280b1',
            }}
          />
        </clipPath>
        <style>
          {
            '.f{fill:none}.g{fill:#006443}.h{fill:#f5aa74}.i{fill:#eb6a36}.j{fill:#f1f1f3}.k{fill:#c280b1}.l{fill:#8cb717}.m{fill:#8f9e69}.n{fill:#b39a4f}.o{fill:#e41c80}.p{fill:#d6993f}.q{fill:#394a35}.r{fill:#497125}.s{clip-path:url(#classmate2-c)}.t{clip-path:url(#classmate2-b)}.u{clip-path:url(#classmate2-e)}.v{clip-path:url(#classmate2-d)}'
          }
        </style>
      </defs>
      <path
        d="M1480.79 926.16s4.27 19.54.61 27.78c-3.66 8.24-9.16 23.81-9.16 23.81l31.44-4.58s3.19-5.25 2.34-12.56c-.85-7.31-6.13-23.87-6.13-23.87l-2.55-14.44-16.55 3.87Z"
        style={{
          fill: '#b39a4f',
        }}
      />
      <path
        d="M1485.27 952.93c8.32.32 17.21 10.49 18.71 10.83 4.08.92.54-6.83 1.71-7.07 1.17-.24 3.39 8.43 4.41 16.08 1.02 7.65 1.53 11.05.17 12.07-1.36 1.02-13.59 6.63-14.95 10.71-1.36 4.08-4.42 15.12-17.5 16.31s-23.79-.51-24.47-4.59c-.68-4.08-1.53-11.9 1.53-15.8 3.06-3.91 9.69-7.65 13.42-14.78 3.74-7.14 7.63-15.9 8.9-18.36 1.38-2.67 3.66-5.55 8.08-5.38Z"
        style={{
          fill: '#497125',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate2-b)',
        }}
      >
        <path
          d="M1446.54 995.54s8.67 7.82 23.96 6.46c15.29-1.36 20.9-5.44 23.62-10.54 2.72-5.1 6.12-9.69 9.18-12.57 3.06-2.89 9.52-9.01 9.52-9.01l.17 26.51s-34.67 33.48-35.52 33.48-42.48-16.48-42.48-16.48l11.56-17.84Z"
          style={{
            fill: '#8f9e69',
          }}
        />
      </g>
      <path
        d="m1498.71 973.62 4.14-6.55s-13-11.41-20.28-10.61c-4.56.5-12.34 8.27-13.55 9.64-1.72 1.94-2.7 7.59.8 5.09 4.12-2.95 5.78-7.93 12.41-7.08 11.21 1.44 16.48 9.52 16.48 9.52Z"
        style={{
          fill: '#8cb717',
        }}
      />
      <path
        d="M1562.53 905.09s8.56 41.42 8.05 47.2c-.51 5.78-1.85 8.57-1.85 8.57l3.57 17.67 35.13-15.94s-14.23-8.34-14.74-12.93c-.51-4.59-5.58-45-5.58-45l-24.58.43Z"
        style={{
          fill: '#b39a4f',
        }}
      />
      <path
        d="M1570.77 954.91c-1.28-.33-3.11 11.65-4.08 15.97-1.8 8.05-.34 15.46.17 16.99.51 1.53 18.52 2.21 28.89 7.65 10.37 5.44 20.56 7.99 32.46 7.99 11.9 0 20.39-4.59 21.24-7.14.85-2.55 2.89-10.03-1.19-12.24-4.08-2.21-18.18-6.8-24.13-10.37-5.95-3.57-23.39-24.9-32.73-19.97-9.35 4.93-10.43 16.74-15.87 14.19-5.44-2.55-3.47-12.75-4.76-13.08Z"
        style={{
          fill: '#497125',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate2-c)',
        }}
      >
        <path
          d="M1563.46 973.26s1.02 6.29 18.35 9.69c17.33 3.4 23.28 8.84 33.99 10.54 10.71 1.7 22.05.64 26.8-1.4s10.07-8.96 10.07-8.96l4.42 30.93s-96.18-4.59-96.52-5.1c-.34-.51-5.95-24.47-5.44-24.64.51-.17 8.33-11.05 8.33-11.05Z"
          style={{
            fill: '#8f9e69',
          }}
        />
      </g>
      <path
        d="m1584.21 971.83 7.73 3.96s10.36-13.42 13.33-14.88c2.8-1.37 4.15-.87 4.15-.87l-7.24-5.6s-5.02-.39-9.47 4.93c-4.44 5.31-8.5 12.46-8.5 12.46Z"
        style={{
          fill: '#8cb717',
        }}
      />
      <path
        d="M1485.99 627.73s-5.22 71.41-1.68 105c3.41 32.39.34 68.37-.85 83.54-1.62 20.63-6.47 63.36-4.95 85.91 1.52 22.55 3.28 46.34 3.28 46.34s4.94 2.87 14.77 2.31c9.83-.56 15.77-3.65 15.77-3.65s2.81-24.76 5.62-53.92c1.92-19.95 3.83-45.79 4.82-52 2.55-15.96 6.87-33.27 10.55-57.18 2.8-18.18 12.37-56.36 12.37-56.36s6.38 57.71 8 78.54c1.62 20.83-.2 40.97.7 65.19 1.04 28.01 14.96 76.82 14.96 76.82s10.76 1.86 18.9.63 12.97-4.97 12.97-4.97-5.92-49-7.08-65.15c-1.29-18.13 4.2-67.37 4.71-85.84.83-29.7 4.65-54.35 3.09-83.22-1.18-21.82 4.58-53.47 4.58-53.47s-118.85-27.84-120.54-28.52Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1543.91 377.36c29.82-4.02 39.54 16.1 44.64 33.88 5.1 17.78.13 30.68.55 44.22.42 13.55 12.02 44.65 12.02 44.65l-9.21 2.92s-12.18-17.6-14.69-26.43c-3.36-11.83-3.58-30.59-3.58-30.59l-47.82.22s3.51 16.99 2.44 30.31c-1.06 13.32-3.95 25.36-3.95 25.36l-14.52 1.11s-.91-4.67 1.45-18.19c1.82-10.44 2.99-22.35 1.08-39.33-.74-6.57-6.46-28.93-2.19-43.34 3.78-12.76 14.6-22.19 33.78-24.77Z"
        style={{
          fill: '#394a35',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate2-d)',
        }}
      >
        <path
          style={{
            fill: '#d6993f',
          }}
          d="m1548.3 399-2.52-25.78-1.37-.04 2.17 25.68 1.72.14z"
        />
      </g>
      <path
        d="M1547.61 397.63s2.54 2.9 12.45 7.65c12.14 5.82 15.19 4.82 19.21 17.23 3.95 12.17 2.63 15.05 2.63 15.05s8.73-7.4 11.41-2.96c2.68 4.44-4.33 16.29-6.76 17.34s-4.75.78-4.75.78.29 9.72-5.96 15.3-10.6 12.8-17.15 12.57c-6.55-.23-22.96-5.03-25.48-8.52-2.52-3.49-7.57-12.43-7.57-12.43s-3.86 2.26-6.7-1.18c-2.84-3.44-12.15-16.56-7.24-18.34 4.92-1.78 9.11 2.3 9.11 2.3s.9-5.04 2.61-17.4c1.17-8.46 2.65-9.52 12.7-17.14 7.52-5.71 10.51-9.82 11.49-10.25Z"
        style={{
          fill: '#d6993f',
        }}
      />
      <path
        d="M1578.45 449.77s-5.78 26.98-2.25 33.09c3.53 6.1 24.09 17.02 24.09 17.02L1564.96 532l-28.27-.96-26.02-36.3s19.92-6.42 21.52-14.78c1.61-8.35-.64-29.23-.64-29.23l46.9-.96Z"
        style={{
          fill: '#d6993f',
        }}
      />
      <path
        style={{
          fill: '#006443',
        }}
        d="m1573.96 431.86-5.63 1.98-.61-2.84 6.16-1.01.08 1.87z"
      />
      <path
        d="M1566.04 428.73c2.57.28 4.19 2.21 3.82 4.71-.37 2.51-2.12 3.35-4.44 3.25-2.74-.12-4.01-1.61-3.89-4.22.08-1.85 1.86-4.03 4.5-3.74ZM1530.19 437.78l5.96-.02-.38-2.88-6.14 1.11.56 1.79z"
        style={{
          fill: '#006443',
        }}
      />
      <path
        d="M1536.6 432.17c-2.33 1.12-3.21 3.48-2.02 5.72 1.19 2.24 3.12 2.45 5.27 1.57 2.54-1.03 3.24-2.86 2.25-5.28-.7-1.71-3.1-3.17-5.5-2.02Z"
        style={{
          fill: '#006443',
        }}
      />
      <path
        d="M1540.72 421.76s-10.17 3.02-12 4.54-2.41 4.16-2.41 4.16l1.14 1.31s1.29-3.12 4.55-3.27c3.26-.15 10.53-2.48 10.53-2.48l-1.81-4.26ZM1560.07 418.71s9.89 1.35 12.1 2.23c2.21.88 4.65 3.07 4.65 3.07l-.88 1.69s-3.09-2.53-6.27-1.67c-3.18.86-10.08-.73-10.08-.73l.47-4.59Z"
        style={{
          fill: '#394a35',
        }}
      />
      <path
        d="M1468.82 673.32s-1.12 10.43-1.15 14.31c-.04 4.93 2.31 18.53.65 23.73-1.66 5.2-6.68 20.07-6.68 20.07s-3.97-.46-4.56-4.07c-.46-2.82 3.72-11.63 2.21-11.91-1.5-.28-7.03 16.38-7.03 16.38s4.29 1.78 4.97 4.97c.68 3.19-.61 4.02-.61 4.02s-10.01-5.89-11.7-6.83c-1.69-.94-5.49-13.65-5.85-17.31-.36-3.66 3.27-10.48 3.9-12.88.62-2.4 5.08-13.77 6.12-19.53 1.03-5.76-.12-19.99-.12-19.99l19.87 9.04ZM1628.05 668.65s6.18 9.78 6.02 13.66c-.25 5.94-4.37 15.1-2.95 20.38 1.42 5.27 6.47 22.02 6.47 22.02s3.25-1.93 4.01-5.51c.59-2.8-3.16-11.79-1.65-12 1.52-.21 6.25 16.69 6.25 16.69s-4.37 1.57-5.2 4.73c-.83 3.16.42 4.04.42 4.04s10.28-5.41 12.01-6.27c1.74-.86 8.82-12.38 9.36-16.01.53-3.64-1.88-11.5-2.82-13.8-4.11-9.97-8.71-22.81-8.35-20.05-.76-5.81-5.01-20.77-5.01-20.77l-18.56 12.9Z"
        style={{
          fill: '#d6993f',
        }}
      />
      <path
        d="M1449.76 662.5s-7.3-2.41-8.59-14.22c-1.29-11.8 8-25.86 17.08-55.68 9.09-29.82 14.68-76.65 24.21-90.67 3.88-5.71 17.54-10.53 22.65-11.38 10.68-1.78 14.95-3.92 14.95-3.92s10.01 8.02 33.08 8.96c22.36.91 29.76-8.27 29.76-8.27s13.96 8.07 21.52 10.43c7.35 2.29 17.79 9.67 21.35 20.91 2.14 6.76.31 37.37 6.32 62.46 6.01 25.09 19.86 44.65 21.92 55.27 4.02 20.68-1.8 22.47-1.8 22.47l.37 15.05-20 5.38-5.31-11.7-4.8-7.45s-4.96 23.01-3.97 29.48c2.7 17.65-16.68 22.65-16.68 22.65s-23.08-7.73-46.49-6.01c-23.41 1.72-70.4 9.36-70.4 9.36s-9.67.35-10.36-12.49c-.66-12.33.47-28.31.53-32.55-2.16 6.37-5.4 15.55-5.4 15.55l-22.59-5.7 2.64-17.94Z"
        style={{
          fill: '#c280b1',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate2-e)',
        }}
      >
        <path
          style={{
            fill: '#eb6a36',
          }}
          d="m1662.37 693.37-34.89 10.81-5.93-35.13 34.4-10.71 6.42 35.03zM1475.19 669.54l-29.93-7.82-9.87 22.94 36.74 8.01 3.06-23.13z"
        />
        <path
          d="M1597.38 556.4s-29.39-6.09-46.02-7.85c-16.63-1.75-53.55-5.36-53.55-5.36l-4.06 21.34s36.57 4.06 55.88 7.11c15.43 2.44 47.75 6.1 47.75 6.1s-.88-20.9 0-21.34Z"
          style={{
            fill: 'none',
          }}
        />
        <path
          d="M1603.29 477.35s-16.64 26.41-55.11 22.68c-37.64-3.65-50.16-22.07-50.16-22.07s55.35-20.39 56.47-20.02c1.12.37 48.8 19.41 48.8 19.41Z"
          style={{
            fill: '#eb6a36',
          }}
        />
      </g>
      <path
        d="M1564.76 458.38c.39 1.71.34 3.81-1.28 5.97-.99 1.33-2 2.73-6.23 3.42-4.77.78-6.42-1.68-7.51-2.11-1.09-.43-3.5-2.16-3.99-4.46-.31-1.48.6-2.65 3.51-3.76 2.85-1.08 5.87.02 5.87.02s2.17-1.35 4.71-1.52c2.42-.16 4.57.86 4.93 2.44Z"
        style={{
          fill: '#f5aa74',
        }}
      />
      <path
        d="M1527.22 485.85s-1.96 12.36-3.05 19.6c-.78 5.17-4.68 9.96-4.68 9.96l.91 4.51s4.61 3.66 6.18 12.71c1.06 6.09 1.06 24.23 1.06 24.23s-16.33-6.99-17.16-19.7c-.47-7.22 1.37-16.42 1.37-16.42l-.55-5.05s-2.53-1.23-2.35-7.53c.35-11.7 2.14-21.26 2.14-21.26l16.13-1.05Z"
        style={{
          fill: '#394a35',
        }}
      />
      <path
        style={{
          fill: '#e41c80',
        }}
        d="m1511.05 515.69.67 5.23 8.66-1.63-.71-4.08-8.62.48z"
      />
    </svg>
  )
}

export default Classmate2End
